export const ONE_CLICK_PROMOTION_BANNER_DISMISSED_KEY =
  'cast_console_one-click_promotion_dismissed';
export const ONE_CLICK_PROMOTION_DIALOG_SEEN_KEY =
  'cast_console_one-click_promotion_dialog_seen';
